import * as React from 'react';
import { cn } from '@/lib/utils';

const ProgressSemicircleWrapper = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      'c-progress-semicircle-wrapper',
      // styles
      'w-34 h-17 relative overflow-hidden text-center',
      className
    )}
    {...props}
  />
));
ProgressSemicircleWrapper.displayName = 'ProgressSemicircleWrapper';

const ProgressSemicircleBar = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      'c-progress-semicircle-bar',
      // styles
      'w-34 h-34 border-6 absolute left-0 top-0 box-border rotate-45 rounded-full border-solid border-primary-lightest border-b-primary border-r-primary transition-transform duration-1000 ease-in',
      className
    )}
    {...props}
  />
));
ProgressSemicircleBar.displayName = 'ProgressSemicircleBar';

const ProgressSemicircleValue = React.forwardRef(({ className, ...props }, ref) => (
  <span
    ref={ref}
    className={cn(
      'c-progress-semicircle-bar',
      // styles
      'absolute bottom-0 left-0 right-0 text-xl font-bold leading-none text-primary',
      className
    )}
    {...props}
  />
));
ProgressSemicircleValue.displayName = 'ProgressSemicircleValue';

export function ProgressSemicircle({ value = 0, style }) {
  return (
    <ProgressSemicircleWrapper style={style}>
      <ProgressSemicircleBar
        style={{
          transform: value <= 100 ? `rotate(${45 + value * 1.8}deg)` : 'rotate(225deg)' // start: 45, end: 225
        }}
      />
      <ProgressSemicircleValue>{value}%</ProgressSemicircleValue>
    </ProgressSemicircleWrapper>
  );
}
